import React from 'react'

export default props => (
  <svg viewBox="0 0 14 15" {...props}>
    <path d="M10.3530882,4.64296621 L8.16581606,2.45569405 L2.3330903,8.28841981 L2.3330903,10.475692 L4.52036246,10.475692 L10.3530882,4.64296621 Z M12.079575,2.91647939 L10.9363608,4.05969364 L8.74908864,1.87242148 L9.89230289,0.729207228 C10.1197792,0.501730924 10.4872409,0.501730924 10.7147172,0.729207228 L12.079575,2.09406506 C12.3070513,2.32154136 12.3070513,2.68900308 12.079575,2.91647939 Z M-4.4408921e-16,12.2255097 L13.9985418,12.2255097 L13.9985418,14.5586 L-4.4408921e-16,14.5586 L-4.4408921e-16,12.2255097 Z" />
  </svg>
)
